import { Box, AppBar, Toolbar, CssBaseline } from "@mui/material";
import { Copyright } from "../Layout/Copyright";
import { useBranding } from "../../branding/BrandingProvider";

interface UnauthenticatedPageLayoutProps {
  children: React.ReactNode;
  hideAppBar?: boolean;
}

const UnauthenticatedPageLayout = ({
  children,
  hideAppBar = false,
}: UnauthenticatedPageLayoutProps) => {
  const brand = useBranding();
  return (
    <Box
      sx={{
        flexGrow: 1,
        backgroundColor: (theme) => theme.palette.background.default,
        height: "100vh",
        overflow: "auto",
      }}
    >
      <CssBaseline />
      {!hideAppBar && (
        <AppBar
          position="static"
          sx={{
            backgroundColor: (theme) => theme.palette.brand.shell.background,
            color: (theme) => theme.palette.brand.shell.text,
            borderBottom: (theme) => `1px solid ${theme.palette.brand.border}`,
          }}
        >
          <Toolbar>
            <img
              src={brand.logoSmall}
              alt={`${brand.displayName} logo`}
              style={{ height: "56px" }}
            />
          </Toolbar>
        </AppBar>
      )}
      {children}
      <Copyright />
    </Box>
  );
};

export default UnauthenticatedPageLayout;
